import React from 'react';

const SurveySection = ({
  currentStep,
  surveyData,
  selectedOptions,
  isLoading,
  handleOptionChange,
  handleNextStep,
  handlePreviousStep,
  handleSubmit,
}) => {
  const currentStepContent = () => {
    switch (currentStep) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        const questionIndex = currentStep - 1;
        return (
          <div className="mb-4" key={currentStep}>
            <p className="block text-gray-700 text-sm font-bold mb-2">
              {surveyData.data[questionIndex]?.question}
            </p>
            {Array.isArray(surveyData.data[questionIndex]?.options) ? (
              surveyData.data[questionIndex].options.map((optionObj, index) => (
                <div key={index} className="flex items-center">
                  <input
                    className="mr-2 leading-tight"
                    type="radio"
                    id={`option_${index}`}
                    name="surveyOption"
                    value={optionObj.option}
                    checked={selectedOptions[currentStep] === optionObj.option}
                    onChange={() => handleOptionChange(optionObj.option)}
                  />
                  <label
                    className="text-gray-700"
                    htmlFor={`option_${index}`}
                  >
                    {String.fromCharCode(65 + index)}. {optionObj.option}
                  </label>
                </div>
              ))
            ) : (
              <p>No options available</p>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
      <div className="max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-semibold mb-4">
          Welcome to our AI-powered survey!
        </h1>
        <p className="text-gray-600 mb-8">
          We'll help you find the best suitable plan for you.
        </p>
        {currentStepContent()}
        <div className="flex justify-between items-center">
          {currentStep !== 1 && (
            <button
              className="bg-transparent hover:bg-gray-100 text-gray-700 font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={handlePreviousStep}
            >
              <svg
                className="w-4 h-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M10 18a1 1 0 01-.707-.293l-7-7a1 1 0 010-1.414l7-7A1 1 0 0110 4a1 1 0 01.707 1.707L4.414 10l6.293 6.293A1 1 0 0110 18z" />
              </svg>
            </button>
          )}
          <button
            className="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            onClick={currentStep === 5 ? handleSubmit : handleNextStep}
            disabled={isLoading}
          >
            {isLoading
              ? "Loading..."
              : currentStep === surveyData.data.length
              ? "Submit"
              : "Next"}
          </button>
          <div className="text-sm text-gray-600">{currentStep}/{surveyData.data.length}</div>
        </div>
      </div>
    </div>
  );
};

export default SurveySection;
